export default "__VITE_ASSET__Snv19mBS__"